<template>
  <input 
    type="date" 
    ref="input" 
    :value="value" 
    format="yyyy-mm-dd"
    @input="$emit('input', $refs.input.value)"
  >
</template>

<script>
export default {
  name: 'iDateField',
  props: ['value'],
};
</script>

